<ion-app>
  <!-- Pinned side menu from lg up (cnt-landing's left-rail look), an overlay below that.
       Off on the sign-in screens, which have no menu. -->
  <ion-split-pane contentId="main-content" when="lg" [disabled]="onAuthPage">
    <ion-menu contentId="main-content" type="overlay" class="admin-menu" [disabled]="onAuthPage">
      <admin-header></admin-header>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
  <admin-toast-host></admin-toast-host>
</ion-app>
